import React from 'react';
import openWindow from '@/script/openWindow.mjs';
import Keyword from './Keyword.jsx';
import cssTable from './SearchTable';
import Table from '@/biz/Table.jsx';

const Pane = ({ param, dataList, rows, setRows, loading }) => {
    const keyword = param.current.keyword;
    const prjPatternId = param.current.prjPatternId;
    const patternRev = param.current.patternRev;

    const onLink = (record) => {
        const mapInits = {
            selectedNodes: [{ path: record.mapPath }],
        }

        if (record.mapVerId) {
            const inits = { ...mapInits };
            openWindow('/SoftwareMap', { id: record.mapVerId, mode: 'snapshot', inits, prjPatternId, patternRev });
        } else {
            openWindow('/AmArDetail', { arId: record.dpId, mapInits });
        }
    }

    const columns = [
        {
            key: 'dpUserCode',
            dataIndex: 'dpUserCode',
            title: '分析报表代码',
            width: '150px',
            ellipsis: true,
            filter: <Table.FilterText />,
        },
        {
            key: 'dpName',
            dataIndex: 'dpName',
            title: '分析报表名称',
            width: '150px',
            ellipsis: true,
            filter: <Table.FilterText />,
        },
        {
            key: 'keywordPath',
            dataIndex: 'keywordPath',
            title: '节点',
            ellipsis: true,
            filter: <Table.FilterText />,
            onCell: (record, index) => {
                return { style: { whiteSpace: 'wrap' } };
            },
            render: (text, record) => {
                // record.mapPath = '/' + encodeURIComponent(record.dpName) + record.keywordEncodePath;
                record.mapPath = record.keywordEncodePath;
                return <a onClick={() => onLink(record)}><Keyword data={text.substr(0, text.length - 1)} keyword={keyword} /></a>;
            }
        }
    ]

    const rowSelection = {
        selectedRowKeys: rows.map(({ pkid }) => pkid),
        onChange: (selectedRowKeys, selectedRows) => {
            setRows(selectedRows);
        },
    }

    return (
        <Table
            code="ar-search"
            size="small"
            loading={loading}
            columns={columns}
            dataSource={dataList}
            css={cssTable}
            rowKey={"pkid"}
            rowSelection={{ type: "checkbox", ...rowSelection }}
        />
    );
}

export default Pane;
